import React, { useState, useEffect } from "react"

import {
  ActualPage,
  Container,
  ImageBox,
  ImageBoxBlur,
  ImageWrapper,
  SlideTitle,
  SubSlideTitle,
  SlideNumber,
  TextBox,
  Pagination,
  PaginationBox,
  HoverTitle,
} from "./styles"

import { SliderLink } from "../../../components/SliderLink"

import { Swiper, SwiperSlide } from "swiper/react"
import { useMousePosition } from "../../../shared/Hooks/useMousePosition"
// Import Swiper styles
import "swiper/swiper.scss"
import { useSliderData } from "../../../shared/Hooks/Slider";

export const Slider = () => {
  const [activeSlide, setActiveSlide] = useState(null)
  const [hoverSlide, setHoverSlide] = useState(false)
  const [currentStyles, setCurrentSlide] = useState(false)
  const [textActive, setTextActive] = useState(false)
  const [styles, setStyles] = useState({})
  const images = useSliderData()
  const position = useMousePosition()

  const options = {
    speed: 800,
    loop: true,
    spaceBetween: 0,
    slidesPerView: 3,
    slidesPerGroup: 1,
    centeredSlides: true,
    slideToClickedSlide: true,
    setWrapperSize: true,
    breakpoints: {
      861: {
        slidesPerView: 3,
        centeredSlides: true,
      },
      601: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      320: {
        slidesPerView: 1,
        centeredSlides: true,
      },
    },
    pagination: {
      el: ".pagination",
      clickable: true,
      renderBullet: function (index, className) {
        return (
          '<span data-name="' +
          images[index].title +
          '"class="' +
          className +
          '">' +
          (index + 1) +
          "</span>"
        )
      },
    },
    onInit: swiper =>
      setTimeout(() => {
        swiper.slideTo(3)
      }, 5),
    onSlideChangeTransitionStart: swiper => {
      setCurrentSlide(true)
    },
    onSlideChangeTransitionEnd: swiper => {
      setCurrentSlide(false)

      let slideTitle = swiper.slides[swiper.activeIndex].getAttribute(
        "data-slide-title"
      )
      setActiveSlide(slideTitle)
    },
  }

  const MoveMe = () => {
    let x = ""
    let y = ""

    x = (position.x - window.innerWidth / 2) * 0.01
    y = -(position.y - window.innerHeight / 2) * 0.01

    return setStyles({
      transform: `rotateX(${y}deg) rotateY(${x}deg)`,
    })
  }

  const showPage = e => {
    let name = e.target.getAttribute("data-name")
    setHoverSlide(name)
  }

  const hideName = () => {
    setHoverSlide(false)
  }

  useEffect(() => {
    let pages = document.querySelectorAll(".swiper-pagination-bullet")

    pages.forEach(page => {
      page.addEventListener("mouseover", showPage)
      page.addEventListener("mouseout", hideName)

      return () => {
        page.removeEventListener("mouseover", showPage)
        page.removeEventListener("mouseout", hideName)
      }
    })
  }, [activeSlide])

  useEffect(() => {
    let timeout = setTimeout(MoveMe, 800)
    return () => {
      clearTimeout(timeout)
    }
  }, [position])

  return (
    <Container>
      <Swiper {...options}>
        {images.map(slide => (
          <SwiperSlide key={slide.title} data-slide-title={slide.title}>
            {({ isActive }) => (
              <div style={isActive ? styles : null}>
                <SliderLink active={isActive} link={slide}>
                  <ImageWrapper className="current">
                    <ImageBox>{slide.image}</ImageBox>
                    <ImageBoxBlur className={isActive ? "hide" : ""}>
                      {slide.blur}
                    </ImageBoxBlur>
                  </ImageWrapper>
                  <TextBox className={isActive ? "active" : ""}>
                    <SubSlideTitle>{slide.subtitle}</SubSlideTitle>
                    <SlideTitle>
                      {slide.title}
                      <SlideNumber>{slide.id}</SlideNumber>
                    </SlideTitle>
                  </TextBox>
                </SliderLink>
              </div>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
      <PaginationBox>
        <Pagination className="pagination" />
        <ActualPage>
          {activeSlide}
          <HoverTitle className={hoverSlide ? "active" : ""}>
            {hoverSlide}
          </HoverTitle>
        </ActualPage>
      </PaginationBox>
    </Container>
  )
}
